import { Field, Formik } from "formik";
import React, { useState } from "react";
import { Input, Select } from "../../../../../../_metronic/_partials/controls";
import * as Yup from "yup";

const validationSchema = Yup.object({
  name: Yup.string().required("Nama tidak boleh kosong!")
});
export default function NotificationTemplateCreateForm({
  onSubmit,
  initialValues
}) {
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ setFieldValue, handleSubmit, handleBlur, values }) => (
        <>
          <div className="form-group row">
            <div className="col-lg-4">
              <Field
                name="name"
                placeholder="Nama template"
                onBlur={handleBlur}
                label="Nama Template"
                component={Input}
              />
            </div>
            <div className="col-lg-4">
              <Select
                name="type"
                label="Tipe Notifikasi"
                onChange={e => setFieldValue(e.target.name, e.target.value)}
              >
                <option value="SMS">SMS</option>
                <option value="EMAIL">Email</option>
                <option value="WHATSAPP">Whatsapp</option>
              </Select>
            </div>
          </div>
          <div className="form-group row">
            <div className="col">
              <label>Template</label>
              <textarea
                name="template"
                className="form-control"
                placeholder="Masukkan template"
                value={values.template}
                onChange={e => setFieldValue(e.target.name, e.target.value)}
              />
            </div>
          </div>
          <button
            className="btn btn-primary float-right"
            onClick={handleSubmit}
          >
            Simpan
          </button>
        </>
      )}
    </Formik>
  );
}
